import { render, staticRenderFns } from "./staking.vue?vue&type=template&id=dd8f15a0&"
import script from "./staking.vue?vue&type=script&lang=js&"
export * from "./staking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports